module.exports = __webpack_public_path__ + "img/section3Card2BrandIcon2.fad9a9dc.svg";